import { useState } from 'react';
import api from './api';
import './LoginPage.css';

export default function LoginPage({ onLogin }) {
  const [userId, setUserId]     = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!userId.trim() || !password.trim()) {
      setError('아이디와 비밀번호를 입력하세요.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/api/account/login', { userId: userId.trim(), password });
      const data = res.data;
      if (data.success) {
        localStorage.setItem('token', data.token);
        onLogin({
          userUid:   data.userUid,
          userId:    data.userId,
          userName:  data.userName,
          authLevel: data.authLevel,
        });
      } else {
        setError(data.message || '로그인에 실패했습니다.');
      }
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        const status = err.response?.status ? `[${err.response.status}]` : '';
        const detail = err.message ?? '알 수 없는 오류';
        setError(`서버 연결 실패 ${status}: ${detail}`);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="lp">
      <div className="lp-box">
        <div className="lp-brand">
          <img src="/logo-full.png" alt="MIN-SOFT" className="lp-logo" />
          <span className="lp-tag">UAM-CTL-2026</span>
          <h1 className="lp-title">종합관제 예측시스템</h1>
          <p className="lp-sub">MINSOFT · DAEGU-GB METRO UAM</p>
        </div>

        <form className="lp-form" onSubmit={handleSubmit} noValidate>
          <div className="lp-field">
            <label className="lp-label" htmlFor="userId">아이디</label>
            <input
              id="userId"
              className="lp-input"
              type="text"
              value={userId}
              onChange={e => setUserId(e.target.value)}
              autoComplete="username"
              autoFocus
              disabled={loading}
            />
          </div>
          <div className="lp-field">
            <label className="lp-label" htmlFor="password">비밀번호</label>
            <input
              id="password"
              className="lp-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          {error && <p className="lp-error">{error}</p>}

          <button className="lp-btn" type="submit" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div className="lp-footer">CONFIDENTIAL · INTERNAL USE ONLY</div>
      </div>
    </div>
  );
}
